import { KrCard } from '@/common/card/KrCard';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { McdInvPrioritizationGrid } from '../charts/McdInvPrioritizationGrid';
import { McdInvPriorQtrPercentCompleteChart } from '../charts/McdInvPriorQtrPercentCompleteChart';
import { McdInvProgressChart } from '../charts/McdInvProgressChart';
import { McdInvSlaCartesianChart } from '../charts/McdInvSlaCartesianChart';
import { McdPymtProgressChart } from '../charts/McdPymtProgressChart';

export const McdInvDashboardOperationsView = ({ formValues, endDateToStartDate, idToMcdInvOrigin }) => {
  return (
    <SpacerLayout>
      <Spacer vertical>
        {/* Row 1 */}
        <Spacer weights={[1, 1, 1.75]}>
          <KrCard title="Invoice Progress" sx={{ flex: 1 }} variant="soft">
            <McdInvProgressChart
              formValues={formValues}
              endDateToStartDate={endDateToStartDate}
              idToMcdInvOrigin={idToMcdInvOrigin}
            />
          </KrCard>

          <KrCard title="Settlement Progress" sx={{ flex: 1 }} variant="soft">
            <McdPymtProgressChart formValues={formValues} endDateToStartDate={endDateToStartDate} />
          </KrCard>

          <KrCard title="Prioritization Grid" sx={{ height: '100%' }}>
            <McdInvPrioritizationGrid
              formValues={formValues}
              endDateToStartDate={endDateToStartDate}
              idToMcdInvOrigin={idToMcdInvOrigin}
            />
          </KrCard>
        </Spacer>

        {/* Row 2 */}
        <Spacer weights={[1, 1, 1.75]}>
          <KrCard title="CLD Progress" sx={{ height: '100%' }} variant="soft">
            <McdInvProgressChart
              formValues={formValues}
              endDateToStartDate={endDateToStartDate}
              idToMcdInvOrigin={idToMcdInvOrigin}
              isCld
            />
          </KrCard>

          <KrCard title="Prior Quarter % Completion" sx={{ height: '100%' }} variant="soft">
            <McdInvPriorQtrPercentCompleteChart formValues={formValues} />
          </KrCard>

          <KrCard title="SLA Tracker" sx={{ height: '100%' }} variant="soft">
            <McdInvSlaCartesianChart formValues={formValues} />
          </KrCard>
        </Spacer>
      </Spacer>
    </SpacerLayout>
  );
};
